import React, { Component } from 'react';
import { ScrollView, Scene, AppHeader } from 'core';
import * as actions from 'actions';
import { lang } from 'lang';
import ACCOUNT from './settings/account';
import SUPPORT from './settings/support';
import SUGGESTIONS from './settings/suggestions';
import DEVICES from './settings/devices';

const item = { ACCOUNT, SUPPORT, SUGGESTIONS, DEVICES };

export default class SettingsContent extends Component {
  render() {
    const { selected_settings_item, ...props } = this.props;
    const Content = item[selected_settings_item];
    return (
      <Scene>
        <AppHeader back title={lang[selected_settings_item]} />
        <ScrollView>{Content && <Content {...props} />}</ScrollView>
      </Scene>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/middle/settings_content.js